import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {type OfferAlternative} from './OfferAlternative';

const t = (key: string, fallback: string) => i18n.t(key, {defaultValue: fallback});

/** Why an alternative cannot be chosen or applied, for the seller; null when it can. */
export const getUnavailableMessage = (reason: OfferAlternative['unavailableReason']) =>
  match(reason)
    .with('SOURCE_CHANGED', () =>
      t(
        'entity.offerAlternative.unavailable.sourceChanged',
        'The vehicle or configuration changed since it was offered. Refresh the alternative so the customer sees the current version.'
      )
    )
    .with('PRICE_EXPIRED', () =>
      t(
        'entity.offerAlternative.unavailable.priceExpired',
        'The configuration price expired. Reprice the configuration, then refresh the alternative.'
      )
    )
    .with('PRICE_MISSING', () =>
      t(
        'entity.offerAlternative.unavailable.priceMissing',
        'The vehicle has no selling price. The customer cannot choose this alternative until a price is set.'
      )
    )
    .with('EXPIRED', () =>
      t(
        'entity.offerAlternative.unavailable.expired',
        'The offer validity of this alternative ended.'
      )
    )
    .with('SOURCE_UNAVAILABLE', 'OFFERED_ELSEWHERE', () =>
      t(
        'entity.offerAlternative.unavailable.source',
        'The vehicle is no longer available for this Business Case. Change the vehicle or withdraw the alternative.'
      )
    )
    .with(null, () => null)
    .exhaustive();
